export class ConvertHelper {

  constructor() {
  }

  static currencyToNumber(amount): number {
    amount = amount.replace(/[^0-9,-]+/g, '');
    amount = parseFloat(amount.replace(',', '.'));
    return  parseFloat(amount.toFixed(2));
  }

}
